import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home/Home'
import FrontPage from '@/components/FrontPage/FrontPage.vue'
import Payments from '@/components/Payments/Payments'
import Debt from '@/components/Debt/Debt'
import LoginToken from '@/components/Login/LoginToken'
import VerifyAuthentication from '@/components/Login/VerifyAuthentication'
import Help from '@/components/Help/Help'
import Profile from '@/components/User/Profile'
import PayEverything from '@/components/PayEverything/PayEverything'
import VerifyPayment from '@/components/Payments/VerifyPayment'
import AuthGuard from './auth-guard'
import LangSelector from '@/components/Shared/LangSelector'
import VerifyReconciliation from '@/components/Reconciliation/VerifySigning'
import VerifyVerdict from '@/components/Verdict/VerifySigning'
import Privacy from '@/components/Privacy/Privacy'
import Error404Page from '@/components/Shared/Error404Page'
import MessengerView from '@/components/Chat/MessengerView'

import store from '../store'

Vue.use(Router)

// Suppress NavigationDuplicated errors globally so individual push() calls don't need their own catch
const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') throw err
  })
}

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      beforeEnter: (to, from, next) => {
        if (!store.getters.authenticated) {
          next()
        } else {
          next('/front-page')
        }
      }
    },
    {
      path: '/login/token/:token*',
      name: 'LoginToken',
      props: true,
      component: LoginToken
    },
    {
      path: '/login/verify',
      name: 'VerifyAuthentication',
      props: route => ({ code: route.query.code, state: route.query.state, session_state: route.query.session_state, error_description: route.query.error_description }),
      component: VerifyAuthentication
    },
    {
      path: '/help',
      name: 'Help',
      component: Help
    },
    {
      path: '/front-page',
      name: 'FrontPage',
      component: FrontPage,
      beforeEnter: AuthGuard
    },
    {
      path: '/pay-all',
      name: 'PayEverything',
      component: PayEverything,
      beforeEnter: AuthGuard
    },
    {
      path: '/profile',
      name: 'Profile',
      component: Profile,
      beforeEnter: AuthGuard
    },
    {
      path: '/debt/:orderNr',
      name: 'SingleDebt',
      component: Debt,
      props: true,
      beforeEnter: AuthGuard
    },
    {
      path: '/payment-plan/:orderNr',
      name: 'PaymentPlan',
      component: Debt,
      props: true,
      beforeEnter: AuthGuard
    },
    {
      path: '/payments',
      name: 'Payments',
      component: Payments,
      beforeEnter: AuthGuard
    },
    {
      path: '/payment/verify',
      name: 'VerifyPayment',
      component: VerifyPayment,
      beforeEnter: AuthGuard
    },
    {
      path: '/lang/:id',
      name: 'LangSelector',
      component: LangSelector,
      props: true
    },
    {
      path: '/reconciliation/verify',
      name: 'VerifyReconciliation',
      props: route => ({ requestId: route.query.requestId, taskId: route.query.taskId }),
      component: VerifyReconciliation,
      beforeEnter: AuthGuard
    },
    {
      path: '/judgement/verify',
      name: 'VerifyVerdict',
      props: route => ({ requestId: route.query.requestId, taskId: route.query.taskId }),
      component: VerifyVerdict,
      beforeEnter: AuthGuard
    },
    {
      path: '/privacy',
      name: 'Privacy',
      component: Privacy
    },
    {
      path: '/messenger',
      name: 'Messenger',
      component: MessengerView,
      beforeEnter: AuthGuard
    },
    {
      path: '*',
      component: Error404Page
    }
  ],
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})
